import { Box, IconButton, Tooltip, useTheme } from "@mui/material";
import { useContext } from "react";
import CloseIcon from "@mui/icons-material/Close";
import MusicPlayer from "./Player";
import AudiotrackIcon from "@mui/icons-material/Audiotrack";
import { PlayerContext } from "../../context/PlayerContext";

const FloatPlayer = () => {
    const theme = useTheme();
     const {
        open,
        } = useContext(PlayerContext);
    return (
        <Box
            sx={{
                position: "fixed",
                bottom: "120px",
                right: "0",
                zIndex: "999",
                marginRight: "20px",
                padding: "3px",
            }}
        >
           {open && <MusicPlayer/>} 
        </Box>
    );
};

export default FloatPlayer;
